import { navigate } from '../lib/router';
import { useStrings } from '../state/AppContext';

export function NotFoundScreen() {
  const t = useStrings();
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center">
      <h2 className="text-lg font-semibold">{t.notFound.title}</h2>
      <p className="text-sm text-dim">{t.notFound.body}</p>
      <button
        type="button"
        className="min-h-[44px] rounded-xl bg-grad-accent px-5 text-sm font-semibold text-white"
        onClick={() => navigate('/')}
      >
        {t.common.backToToday}
      </button>
    </div>
  );
}
